// extracted by mini-css-extract-plugin
export var center = "_56-2";
export var clickableRow = "_56-5";
export var expandedRow = "_56-7";
export var hoverable = "_56-4";
export var left = "_56-1";
export var right = "_56-3";
export var row = "_56-0";
export var selectedRow = "_56-6";
export var summaryRow = "_56-8";